import { createStore } from 'vuex'
import authModule from "@/store/modules/auth.module";
import dateModule from "@/store/modules/date.module";
import menuModule from "@/store/modules/menu.module";
import contractModule from "@/store/modules/contract.module";
import docsModule from "@/store/modules/docs.module";
export default createStore({
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {
  },
  modules: {
    authModule, contractModule, menuModule, dateModule, docsModule
  }
})
